var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7936 1.51312C6.6275 1.51312 1.62891 6.51172 1.62891 12.6778C1.62891 18.844 6.6275 23.8426 12.7936 23.8426C18.9597 23.8426 23.9583 18.844 23.9583 12.6778C23.9583 6.51172 18.9597 1.51312 12.7936 1.51312ZM10.8184 17.8689L18.9401 8.00677L17.7649 7.03889L10.7092 15.6066L7.71885 12.6163L6.64232 13.6928L10.8184 17.8689Z",
    fill: "#08A98A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneIcon);
export default __webpack_public_path__ + "static/media/doneIcon.177b4dab2246c43afe39813efb7dc983.svg";
export { ForwardRef as ReactComponent };